import { BehaviorSubject } from "rxjs";
import { WeeklyVarianceService } from "./weekly-variance.service";

export interface accountMasterDetail{
    accountsMasterId: number;
    accountDetailId: number;
    accountDescription: string;
}

export interface accountDetail{
    accountsMasterId: number|null;
    accountNumber: number|string|null;
    accountDescription: string|null;
}

export interface WeeklyVariance{
    weeklyVarianceId?:number|null;
    projectId:number;
    varianceAmount:number;
    varianceComment:string;
    displayOrder:number;
    accountsMasterId:number|null;
}

export interface WeeklyVarianceUi{
    weeklyVarianceId?:number|null;
    projectId:number;
    varianceAmount:number;
    varianceComment:string;
    order:number;
    displayOrder:number;
    accountsMasterId:number|null;
    accountNumber: number|null;
    accountDescription: number|null;
}

export let accountMasterList = new BehaviorSubject<accountMasterDetail[]>([]);

let defaultWeeklyVarianceBlankRows:number=1;

export function weeklyVarianceDataServiceToUi(projectId:number, sData:WeeklyVariance[]|null, oldData?:WeeklyVarianceUi[]){

    let uData:WeeklyVarianceUi[];

    if(oldData && sData){
        uData=oldData;
        for(let s of sData){
            for(let u of uData){
                if(u.displayOrder==s.displayOrder){
                    u.weeklyVarianceId=s.weeklyVarianceId;
                    break;
                }
            }
        }
    }
    else{
        uData=[];
        
        if(sData==null){
            let count = defaultWeeklyVarianceBlankRows;
            while(count){
                let emptyData:WeeklyVarianceUi={
                    projectId: projectId,
                    varianceAmount: 0,
                    varianceComment: "",
                    order: defaultWeeklyVarianceBlankRows - count + 1,
                    displayOrder: 0,
                    accountsMasterId: null,
                    accountNumber: null,
                    accountDescription: null,
                    weeklyVarianceId:null
                }
                uData.push(emptyData);
                count-=1;
            }
        }
        else{
            for(let s of sData){
                let data:WeeklyVarianceUi={
                    projectId: s.projectId,
                    varianceAmount: s.varianceAmount,
                    varianceComment: s.varianceComment,
                    accountsMasterId: s.accountsMasterId,
                    accountNumber: s.accountsMasterId,
                    accountDescription: s.accountsMasterId,
                    weeklyVarianceId:s.weeklyVarianceId,
                    displayOrder: s.displayOrder,
                    order: s.displayOrder,
                }
                uData.push(data);
            }
        }
    }
     
    return uData;

}


export function weeklyVarianceDataUiToService(uData:WeeklyVarianceUi[]){

    let sData:WeeklyVariance[]=[];

    let displayOrder =1;
    for(let u of uData){
        // if(u.accountsMasterId==null && (!u.varianceComment || u.varianceComment.trim()=='') && u.varianceAmount==0){
        //     u.displayOrder=0;
        //     u.weeklyVarianceId=null;
        //     continue;
        // }
        let data:WeeklyVariance={
            projectId: u.projectId,
            varianceAmount: u.varianceAmount,
            varianceComment: u.varianceComment,
            displayOrder: displayOrder,
            accountsMasterId: u.accountsMasterId,
            weeklyVarianceId: u.weeklyVarianceId
        }
            
        u.displayOrder = displayOrder;
        displayOrder+=1;
        sData.push(data);
    }
            
    return {
        sData: sData,
        uData: uData
    };

}